'use client'
import { jsxs, jsx } from 'react/jsx-runtime';
import { useTranslation } from 'react-i18next';
import { LinearGradientFrame } from '../../../../../components/LinearGradientFrame/LinearGradientFrame.js';
import 'react';
import { ReactComponent as SvgWalletWithSunglasses } from '../../../../../shared/assets/wallet-with-sunglasses.js';
import '@dynamic-labs/iconic';
import '../../../../../context/ViewContext/ViewContext.js';
import { Typography } from '../../../../../components/Typography/Typography.js';

const EmptyScreen = () => {
    const { t } = useTranslation();
    return (jsxs("div", { className: 'empty-screen', children: [jsx(LinearGradientFrame, { Icon: jsx(SvgWalletWithSunglasses, {}) }), jsx(Typography, { variant: 'title', color: 'secondary', className: 'empty-screen__title', copykey: 'dyn_settings.empty_screen.title', children: t('dyn_settings.empty_screen.title') })] }));
};

export { EmptyScreen };
